import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendBlogSeoAnalysis, BackendQueryBlogSeoAnalysisArgs } from 'src/types/backend';

const QUERY = gql`
  query BlogSeoAnalysis($projectId: ID!, $draftId: ID!) {
    blogSeoAnalysis(projectId: $projectId, draftId: $draftId) {
      status
      data {
        keywords
        wordCountRange
        paragraphRange
        headlineRange
      }
    }
  }
`;

type Variables = BackendQueryBlogSeoAnalysisArgs;
type Result = BackendBlogSeoAnalysis;

export const queryBlogSeoAnalysis = async (variables: Variables) => {
  const result = await executeGqlQuery({ query: QUERY, variables });
  return getSingleProp<Result>(result.data);
};
